export const ECOMMERCE_ACCOUNT_LOADED = 'ECOMMERCE_ACCOUNT_LOADED';
export const ECOMMERCE_ACCOUNT_REQUEST = 'ECOMMERCE_ACCOUNT_REQUEST';
export const ECOMMERCE_ACCOUNT_FAILURE = 'ECOMMERCE_ACCOUNT_FAILURE';

export const PLAN_TYPE_HOST_PLUS = 'HOST_PLUS';
export const PLAN_TYPE_FREEMIUM = 'FREEMIUM';
